import React from 'react';
import { CustomPicker } from 'react-color';
import { EditableInput } from 'react-color/lib/components/common';

class ColorPickerField extends React.Component {
  inputStyles = {
    label: {
      paddingRight: '5px',
      paddingLeft: '5px',
    },
  };

  render() {
    const { label, value, handleChange } = this.props;
    return (
      <EditableInput
        style={ this.inputStyles }
        label={label}
        value={value}
        onChange={handleChange}
      />
    );
  }
}

export default CustomPicker(ColorPickerField);



// WEBPACK FOOTER //
// ./src/components/common/form/elements/color-picker-field.jsx